// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1iTYO","col":"Table_col__2P0Ku","fulfillmentStatus":"Table_fulfillmentStatus__2ixij","emailCol":"Table_emailCol__2Mm51"};